import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import { API_AXIOS } from "../../http/interceptor";

export const upcomingEvents = createApi({
  reducerPath: "upcomingEvents",
  baseQuery: fetchBaseQuery({ baseUrl: Apis.baseUrl }),
  tagTypes: ["upcomingEvents"],
  endpoints: (builder) => ({
    getUpEvents: builder.query({
      query: ({
        page = 1,
        limit,
        search,
        pagination = true,
        includeCurrent = false,
      }) => ({
        url: Apis.event + "/upcoming",
        params: {
          page,
          limit,
          search,
          pagination,
          includeCurrent,
        },
      }),
      providesTags: ["upcomingEvents"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetUpEventsQuery } = upcomingEvents;

export const eventsApi = createApi({
  reducerPath: "eventsList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Events"],
  endpoints: (builder) => ({
    getEventsData: builder.query({
      queryFn: async ({
        page = 1,
        limit = 20,
        search,
        city,
        country,
        startDate,
        endDate,
      }) => {
        try {
          const { data } = await API_AXIOS.get(Apis.eventsList, {
            params: {
              page,
              limit,
              search,
              city,
              country,
              startDate,
              endDate,
            },
          });
          return { data };
        } catch (error) {
          return { error: error.response?.data || error.message };
        }
      },
      providesTags: ["Events"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetEventsDataQuery } = eventsApi;

export const eventDetailsApi = createApi({
  reducerPath: "eventDetails",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["eventDetails"],
  endpoints: (builder) => ({
    getEventDetails: builder.query({
      query: (id) => ({
        url: `${Apis.event}/details/${id}`,
      }),
      providesTags: ["eventDetails"],
      keepUnusedDataFor: 300,
      transformResponse: (data) => data.data,
    }),
  }),
});

export const { useGetEventDetailsQuery } = eventDetailsApi;
